module.exports = __webpack_public_path__ + "static/media/sf_2200.b664f162c72e422088f16d87cc0b2e00.png";